import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { normalizePaymentQueryString } from "../../../utils/paymentCallbackParams";

/** OPPWA lands here first; we immediately return to the app shell and show a modal overlay. */
const PaymentCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = normalizePaymentQueryString(location.search);
    const returnTo = params.get("returnTo") ?? "saleOrder";

    let path: string;
    if (returnTo === "wallet") {
      path = `/walletBalance?${params.toString()}`;
    } else if (returnTo === "dashboard") {
      path = `/dashboard?${params.toString()}`;
    } else {
      path = `/saleOrder?tab=OrderHistory&${params.toString()}`;
    }

    navigate(path, { replace: true });
  }, [navigate, location.search]);

  return null;
};

export default PaymentCallbackPage;
